import './App.css'
import Aos from 'aos';
import "aos/dist/aos.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Navbar from './folder/components/Navbar';

import {
  createBrowserRouter,
  RouterProvider
} from "react-router-dom";
import Footer from './folder/components/Footer';
import About from './pages/About';
import FidelitusGallery from './pages/other_business/FidelitusGallery';
import ShilpaFoundation from './pages/other_business/ShilpaFoundation';
import Contact from './pages/Contact';
import Home from './pages/Home';
import FMSService from './pages/other_business/FMSService';
import Projects from './pages/other_business/Projects';
import HRManagement from './pages/other_business/HRManagement';
import RealEstate from './pages/other_business/RealEstate';
import { useEffect,useState } from 'react';
import ChairmanMessage from './pages/ChairmanMessage';
import Whyus from './pages/Whyusdata.js';
import Blogs from './pages/Blogs.js';
import BlogDetail from './pages/BlogsDetail.js';
import Joinus from './pages/Joinus.js';
import Splash from './pages/Splash.js';
import { Toaster } from 'react-hot-toast';

function App() {

  const [loader,setloader] = useState(false)

  useEffect(()=>{
    // setloader(true)
    // setTimeout(() => {
    //   setloader(false)
    // }, 2000);
    Aos.init();
  },[])

  const router = createBrowserRouter([
    {
      path: "/",
      element: (
        <div>
          <Navbar />
          <Home />
          <Footer />
        </div>
      ),
    },
    {
      path: "/home",
      element: (
        <div>
          <Navbar />
          <Home />
          <Footer />
        </div>
      ),
    },
    {
      path: "/about/chairman_message",
      element: (
        <div>
          <Navbar />
          <ChairmanMessage />
          <Footer />
        </div>
      ),
    },
    {
      path: "/about/our_vision",
      element: (
        <div>
          <Navbar />
          <About />
          <Footer />
        </div>
      ),
    },
    {
      path: "/contact",
      element: (
        <div>
          <Navbar />
          <Contact />
          <Footer />
        </div>
      ),
    },
    {
      path: "/blogs",
      element: (
        <div>
          <Navbar />
          <Blogs />
          <Footer />
        </div>
      ),
    },
    {
      path: "/blogs/detail/:id",
      element: (
        <div>
          <Navbar />
          <BlogDetail />
          <Footer />
        </div>
      ),
    },
    {
      path: "/why-us",
      element: (
        <div>
          <Navbar />
          <Whyus />
          <Footer />
        </div>
      ),
    },
    {
      path: "/join_us",
      element: (
        <div>
          <Navbar />
          <Joinus />
          <Footer />
        </div>
      ),
    },
    {
      path: "/projects",
      element: (
        <div>
          <Navbar />
          <Projects />
          <Footer />
        </div>
      ),
    },
    {
      path:"/real-estate",
      element: (
        <div>
          <Navbar />
          <RealEstate />
          <Footer />
        </div>
      ),
    },
    {
      path: "/hr-labs",
      element: (
        <div>
          <Navbar />
          <HRManagement />
          <Footer />
        </div>
      ),
    },
    {
      path: "/facility-management-services",
      element: (
        <div>
          <Navbar />
          <FMSService />
          <Footer />
        </div>
      ),
    },
    {
      path: "/fidelitus_gallery",
      element: (
        <div>
          <Navbar />
          <FidelitusGallery />
          <Footer />
        </div>
      ),
    },
    {
      path: "/shilpa_foundation",
      element: (
        <div>
          <Navbar />
          <ShilpaFoundation />
          <Footer />
        </div>
      ),
    },
  ])
  return (
    <div className='w-auto max-w-[100vw] overflow-x-hidden'>
      <Toaster  position="bottom-center" toastOptions={{
          success: {
            style:{
              background:'black',
              color:'white',
              padding:'4px 7px',
              fontSize:'12px',
              borderRadius:'2px',
              iconTheme: {
                fontSize:'4px'
              }
            }
          },
          error: {
            style:{
              background:'black',
              color:'white',
              padding:'4px 7px',
              fontSize:'12px',
              borderRadius:'2px',
              iconTheme: {
                fontSize:'4px'
              }
            }
          }
        }}  />
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
